<template>
  <div style="width: 100%">
    <v-card
      class="card-pad justify-center d-flex align-center mb-4"
      height="75"
      width="100%"
    >
      <h3><strong>Padrão de Segurança Elétrica</strong></h3>
    </v-card>

    <v-form ref="form" style="width: 100%">
      <v-card class="card-pad pa-0 pb-2 mt-4">
        <div class="px-4">
          <v-row class="ma-0" dense justify="end">
            <v-col class="d-flex align-center">
              <strong>{{ $t('Dados gerais') }}</strong>
              <v-spacer></v-spacer>
              <v-checkbox
                v-model="isBorrowed"
                v-if="!isEditing"
                @change="reset"
                class="my-2"
                hide-details
                :label="$t('Padrão de outra instituição')"
                color="#BBCF20"
              ></v-checkbox>
            </v-col>
          </v-row>
        </div>

        <v-divider />

        <div class="px-4" v-if="!isBorrowed">
          <v-row class="ma-0" dense>
            <v-col cols="12" sm="6" md="4">
              <label class="label">{{ $t('Instituição') }}</label>
              <v-autocomplete
                hide-details="auto"
                :disabled="true"
                v-model="pattern.institutionId"
                :loading="institutionLoading"
                :items="institutions"
                item-text="name"
                item-value="id"
                outlined
                append-icon="mdi-chevron-down"
                class="primary-input"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <label class="label">{{ $t('Equipamento') }}</label>
              <v-autocomplete
                hide-details="auto"
                :disabled="loading"
                v-model="pattern.equipmentId"
                :loading="equipmentLoading"
                :items="equipments"
                item-text="name"
                item-value="id"
                :rules="[(v) => !!v || 'Equipamento obrigatório']"
                outlined
                append-icon="mdi-chevron-down"
                @change="setEquipmentAndPatternName"
                class="primary-input"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>

                <template v-slot:item="{ item }">
                  <span class="text-caption">
                    {{ item.identification }} / {{ item.name }}
                  </span>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <label class="label">{{ $t('Nome do padrão') }}</label>
              <v-text-field
                hide-details="auto"
                :disabled="loading"
                v-model="pattern.name"
                outlined
                :rules="[(v) => !!v || 'Nome do padrão obrigatório']"
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <label class="label">{{ $t('Unidade') }}</label>
              <v-autocomplete
                hide-details="auto"
                :disabled="loading"
                readonly
                v-model="selectedEquipment.unidadeId"
                :loading="unidadeLoading"
                :items="unidades"
                item-text="name"
                item-value="id"
                outlined
                append-icon="mdi-chevron-down"
                class="primary-input"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <label class="label">{{ $t('Modelo') }}</label>
              <v-text-field
                hide-details="auto"
                :disabled="loading"
                readonly
                v-model="selectedEquipment.model"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <label class="label">{{ $t('Código de patrimônio') }}</label>
              <v-text-field
                hide-details="auto"
                :disabled="loading"
                readonly
                v-model="selectedEquipment.propertyCode"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <label class="label">{{ $t('Número de série') }}</label>
              <v-text-field
                hide-details="auto"
                :disabled="loading"
                readonly
                v-model="selectedEquipment.serialNumber"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="4">
              <label class="label">{{ $t('Fabricante') }}</label>
              <v-text-field
                hide-details="auto"
                :disabled="loading"
                v-model="selectedEquipment.manufacturer"
                readonly
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>
          </v-row>
        </div>

        <div class="px-4" v-else>
          <v-row class="ma-0" dense>
            <v-col cols="12" sm="6" md="4">
              <label class="label">{{ $t('Instituição') }}</label>
              <v-autocomplete
                hide-details="auto"
                v-model="borrowInstitutionId"
                :loading="institutionLoading"
                :items="institutions.filter((x) => x.id != institution.id)"
                item-text="name"
                item-value="id"
                outlined
                :rules="[(v) => !!v || 'Instituição obrigatório']"
                append-icon="mdi-chevron-down"
                class="primary-input"
                @change="getInstitutionBorrowedEquipments(), listPatterns()"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="label">{{ $t('Padrão') }}</label>
              <v-autocomplete
                hide-details="auto"
                return-object
                v-model="pattern"
                :loading="patternLoading"
                :items="patternsList"
                item-text="name"
                item-value="id"
                placeholder="Selecione o padrão"
                :rules="[(v) => !!v || 'Padrão obrigatório']"
                outlined
                append-icon="mdi-chevron-down"
                class="primary-input"
                @change="setEquipment"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="label">{{ $t('Equipamento') }}</label>
              <v-autocomplete
                hide-details="auto"
                readonly
                :disabled="loading"
                v-model="pattern.equipmentId"
                :loading="equipmentLoading"
                :items="equipments"
                item-text="name"
                item-value="id"
                :rules="[(v) => !!v || 'Equipamento obrigatório']"
                outlined
                append-icon="mdi-chevron-down"
                @change="setEquipmentAndPatternName"
                class="primary-input"
              >
                <template #message="{ message }">
                  {{ $t(message) }}
                </template>

                <template v-slot:item="{ item }">
                  <span class="text-caption">
                    {{ item.identification }} / {{ item.name }}
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </div>
      </v-card>

      <v-card class="card-pad pa-0 pb-2 mt-4">
        <div class="px-4 py-3">
          <v-row class="ma-0" dense justify="end">
            <v-col class="d-flex align-center">
              <strong>{{ $t('Dados do certificado') }}</strong>
              <v-spacer></v-spacer>
            </v-col>
          </v-row>
        </div>

        <v-divider />

        <div class="px-4">
          <v-row class="ma-0" dense>
            <v-col cols="12" sm="6" md="4">
              <label class="label">{{ $t('Número') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="pattern.number"
                :disabled="isBorrowed"
                outlined
                :rules="[(v) => !!v || 'Número obrigatório']"
                class="primary-input"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="label">{{ $t('Órgão calibrador') }}</label>
              <v-text-field
                hide-details="auto"
                v-model="pattern.calibratingOrgan"
                :disabled="isBorrowed"
                :rules="[(v) => !!v || 'Órgão calibrador obrigatório']"
                outlined
                class="primary-input"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <label class="label">{{ $t('Data de Validade') }}</label>
              <date-picker
                ref="datepicker"
                style="width: 100%"
                v-model="pattern.expirationDate"
                mode="dateTime"
                is24hr
                :popover="{ visibility: 'click' }"
              >
                <template v-slot="{ inputValue, inputEvents }">
                  <v-text-field
                    outlined
                    class="primary-input"
                    :disabled="isBorrowed"
                    prepend-inner-icon="mdi-calendar"
                    :value="inputValue"
                    v-on="inputEvents"
                    hide-details
                    v-mask="['##/##/####']"
                    @focus="setNowDate"
                  />
                </template>
              </date-picker>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-form>

    <div class="d-flex justify-space-between mt-4">
      <v-btn
        depressed
        class="quaternary-button"
        small
        color="#B14949"
        to="/electricalSafety"
      >
        {{ $t('Cancelar') }}
      </v-btn>
      <v-btn
        depressed
        class="secondary-button ma-0"
        small
        :loading="loading"
        @click="save"
      >
        {{
          isBorrowed
            ? 'Solicitar padrão'
            : isEditing
            ? 'Atualizar'
            : 'Adicionar'
        }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../services/ApiService'

export default {
  data() {
    return {
      borrowInstitutionId: false,
      isBorrowed: false,
      isEditing: false,
      pattern: {
        expirationDate: '',
      },
      selectedEquipment: {},
      institution: {},
      equipments: [],
      institutions: [],
      unidades: [],
      patternsList: [],
      loading: false,
      unidadeLoading: false,
      patternLoading: false,
      institutionLoading: false,
      equipmentLoading: false,
      apiService: new ApiService(),
    }
  },

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))

    Promise.all([
      this.getEquipments(),
      this.getInstitutions(),
      this.getUnidades(),
    ])

    const id = this.$route.query.id
    if (id) {
      this.isEditing = true
      this.getPattern(id)
    } else this.pattern.institutionId = this.institution.id
  },

  methods: {
    getInstitutionBorrowedEquipments() {
      this.equipmentLoading = true
      this.apiService
        .get(`equipment/electricalSafety/${this.borrowInstitutionId}`)
        .then((response) => {
          this.equipments = response.content
          this.equipmentLoading = false
        })
        .catch(() => {
          this.equipmentLoading = false
        })
    },

    setEquipment() {
      console.log(this.pattern.equipmentId)
      this.selectedEquipment = this.equipments.find(
        (x) => x.id == this.pattern.equipmentId
      )
      console.log(this.selectedEquipment)
    },

    reset() {
      this.pattern = {}
      this.selectedEquipment = {}
    },

    listPatterns() {
      if (!this.borrowInstitutionId) return

      this.patternLoading = true

      this.apiService
        .get('electricalSafetyPattern/list/' + this.borrowInstitutionId)
        .then((response) => {
          this.patternsList = response.content
          this.patternLoading = false
        })
        .catch(() => {
          this.patternLoading = false
        })
    },

    setEquipmentAndPatternName() {
      const equip = this.equipments.find(
        (x) => x.id == this.pattern.equipmentId
      )

      if (equip) {
        this.selectedEquipment = equip
        this.pattern.name = `Padrão - ${equip.name}`
      } else {
        this.selectedEquipment = {}
        this.pattern.name = ``
      }
    },

    setNowDate() {
      this.pattern.expirationDate = !this.pattern.expirationDate
        ? new Date()
        : this.pattern.expirationDate
    },

    getUnidades() {
      this.unidadeLoading = true
      this.apiService
        .get(`unidade/list/${this.institution.id}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
        .catch(() => {
          this.unidadeLoading = false
        })
    },

    getInstitutions() {
      this.institutionLoading = true
      this.apiService
        .get(`institution/list`)
        .then((response) => {
          this.institutions = response.content
          this.institutionLoading = false
        })
        .catch(() => {
          this.institutionLoading = false
        })
    },

    getEquipments() {
      this.equipmentLoading = true
      this.apiService
        .get(`equipment/simulator-analyzer-standard/${this.institution.id}`)
        .then((response) => {
          this.equipments = response.content
          this.equipmentLoading = false
        })
        .catch(() => {
          this.equipmentLoading = false
        })
    },

    getPattern(id) {
      this.loading = true
      this.apiService
        .get(`electricalSafetyPattern/${id}`)
        .then((response) => {
          this.pattern = response.content
          this.selectedEquipment = this.pattern.equipment
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    save() {
      if (!this.$refs.form.validate()) return

      if (this.isBorrowed) {
        this.requestBorrow()
        return
      }

      if (this.isEditing) {
        this.edit()
      } else {
        this.add()
      }
    },

    requestBorrow() {
      this.loading = true

      const model = {
        institutionRequesterId: this.institution.id,
        electricalSafetyPatternId: this.pattern.id,
      }

      this.apiService
        .post('electricalSafetyPattern/request-borrow', model)
        .then((response) => {
          this.loading = false
          this.$toast.success('Padrão solicitado com sucesso!')
          this.$router.push('/electricalSafety')
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    add() {
      this.loading = true
      this.apiService
        .post('electricalSafetyPattern', this.pattern)
        .then((response) => {
          this.loading = false
          this.$toast.success('Padrão adicionado! 👍​')
          this.$router.push('/electricalSafety')
        })
        .catch(() => {
          this.loading = false
        })
    },

    edit() {
      this.loading = true
      this.apiService
        .put('electricalSafetyPattern', this.pattern)
        .then((response) => {
          this.loading = false
          this.$toast.success('Padrão atualizado!')
          this.$router.push('/electricalSafety')
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style scoped>
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}
</style>
